import { gql } from '@grandvisionhq/graphql';

var NearestStoreFragment = gql`
  fragment NearestStore on Store {
    code
    slug
    town
    shortName
    storeDetailImage
    distance
    breadcrumbName
    breadcrumbSlug
  }
`;

export { NearestStoreFragment as default };
//# sourceMappingURL=nearest-store.js.map
